import { assetUrl } from '../../../../single-spa/asset-url';
import { Injectable } from '@angular/core';
import { ICountrywiseTimezone, ISettingsResponse, ITimeZone, Settings } from '../models/settings.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { environment, SkipInterceptorHeader } from './util.service';
import { IResponse, IDealerInfo } from '@signal/asp-data-commons';
import { selectDealerCode } from '../../store/dealer/dealer.selectors';
import { Store } from '@ngrx/store';
import { DealerState } from '../../store/dealer/dealer.reducer';
import { StateDetails } from '../models/state';
import { TranslateService } from '@ngx-translate/core';
import { Departments } from '../enums/departments.enum';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private apiRoot: string;
  private readonly aspAppointmentApi: string;

  constructor(private readonly http: HttpClient,
    private readonly dealerState: Store<DealerState>, private translate: TranslateService) {
    this.apiRoot = environment.aspAvailabilityApi;
    this.aspAppointmentApi = environment.aspAppointmentApi;

  }

  getAllSettings(dealerCode: string): Observable<IResponse<IDealerInfo>> {
    return this.http.get(`${(this.apiRoot)}generalsettings/${dealerCode}`).pipe(
      map((data: IResponse<IDealerInfo>) => {
        return data;
      }));
  }

  getSettings(department: string): Observable<ISettingsResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}generalsettings/${dealerCode}/${department}`).pipe(
        map((data: any) => {
          return data;
        })
      )
    }));
  }

  updateSettings(department: string, settings: Settings): Observable<ISettingsResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.put(`${this.apiRoot}generalsettings/${dealerCode}/${department}`, settings).pipe(
        map((data: any) => {
          return data;
        })
      )
    }));
  }

  getPMAZipCodes(department: string): Observable<ISettingsResponse> {
    return this.dealerState.select(selectDealerCode).pipe(switchMap(dealerCode => {
      return this.http.get(`${this.apiRoot}generalsettings/${dealerCode}/${department}/zipcodes`).pipe(
        map((data: any) => {
          return data;
        })
      );
    }));
  }

  getTimezones(): Observable<ITimeZone[]> {
    const headers = new HttpHeaders().set(SkipInterceptorHeader, '');
    return this.http.get(assetUrl(`data/timezone.json`), { headers }).pipe(
      map((data: IResponse<ICountrywiseTimezone[]>) => {
        return data.data.find(x => this.translate.currentLang?.includes(x.countryCode))?.timezones;
      })
    )
  }

  getTimeDuration(department: string) {
    if(department === Departments.SALES){
      return [
        {
          'label': '15min',
          'value': 15
        },
        {
          'label': '20min',
          'value': 20
        },
        {
          'label': '30min',
          'value': 30
        },
        {
          'label': '45min',
          'value': 45
        },
        {
          'label': '60min',
          'value': 60
        },
        {
          'label': '90min',
          'value': 90
        },
        {
          'label': '120min',
          'value': 120
        },{
          'label': '180min',
          'value': 180
        }];
    } else {
      return [
        {
          'label': '15min',
          'value': 15
        },
        {
          'label': '20min',
          'value': 20
        },
        {
          'label': '30min',
          'value': 30
        },
        {
          'label': '45min',
          'value': 45
        },
        {
          'label': '60min',
          'value': 60
        }];
    }
    
  }

  getCutOffTime() {
    return [
      {
        'label': '0 hrs',
        'value': 0
      },
      {
        'label': '1 hrs',
        'value': 1
      },
      {
        'label': '2 hrs',
        'value': 2
      },
      {
        'label': '6 hrs',
        'value': 6
      },
      {
        'label': '12 hrs',
        'value': 12
      },
      {
        'label': '18 hrs',
        'value': 18
      },
      {
        'label': '24 hrs',
        'value': 24
      },
      {
        'label': '36 hrs',
        'value': 36
      },
      {
        'label': '48 hrs',
        'value': 48
      },
      {
        'label': '72 hrs',
        'value': 72
      }
    ];
  }

  getStates(): Observable<StateDetails[]> {
    const headers = new HttpHeaders().set(SkipInterceptorHeader, '');
    return this.http.get(assetUrl(`data/states.json`), { headers }).pipe(
      map((data: StateDetails[]) => {
        return data;
      })
    )
  }

  getCities(): Observable<{ [key: string]: string[] }> {
    const headers = new HttpHeaders().set(SkipInterceptorHeader, '');
    return this.http.get(assetUrl(`data/cities.json`), { headers }).pipe(
      map((data: { [key: string]: string[] }) => {
        return data;
      })
    )
  }
  getDashboardContents(): Observable<any[]> {
    const headers = new HttpHeaders().set(SkipInterceptorHeader, '');
    return this.http.get(assetUrl(`data/dashboard-contents.json`), { headers }).pipe(
      map((data: any[]) => {
        return data;
      })
    )
  }

  syncDealerDisDetails(){
    return this.dealerState.select(selectDealerCode).pipe(switchMap(code => {
      return this.http.post(`${this.aspAppointmentApi.replace("/api", "")}dealerdisdetailsupdate`,{
        dealerCodes:[code]
      }).pipe(
            map((data: any) => {
              return data;
            }))
        }));
      }
}
